/**
 * URL module — lightweight query-parameter utilities.
 *
 * All functions operate on `window.location` and use the History API.
 * No dependencies.
 */

/**
 * Returns the value of a URL query parameter, or `null` if absent.
 * @param {string} key
 * @returns {string | null}
 */
export function getParam(key) {
  return new URLSearchParams(window.location.search).get(key);
}

/**
 * Sets a URL query parameter without reloading the page.
 * Removes the parameter entirely when `value` strictly equals `defaultValue`.
 *
 * @param {string}         key
 * @param {string | number} value
 * @param {Object}          [options]
 * @param {string | number} [options.defaultValue] - Remove the param when value equals this.
 * @param {*}               [options.state]        - History pushState state object.
 */
export function setParam(key, value, { defaultValue, state = {} } = {}) {
  const url = new URL(window.location.href);

  if (defaultValue != null && value === defaultValue) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }

  window.history.pushState(state, '', url);
}
